




































import { Component, Prop, Vue } from 'vue-property-decorator'
import { availableReferralTypes } from '@/api/types'
import { ReferralNode } from '@/api/model/referral-node'

@Component
export default class EditIncomingReferralNodeForm extends Vue {
    @Prop({ required: true }) readonly value!: ReferralNode

    get referralTypeOptions() {
        return availableReferralTypes().map(referralType => {
            return {
                label: this.$t(`referral.type.${referralType}`),
                value: referralType,
            }
        })
    }

    get excludedReferralFieldsOptions() {
        return [
            {
                label: this.$t(`excludedReferralFields.orderValue`),
                value: 'orderValue',
            },
            {
                label: this.$t(`excludedReferralFields.nettoOrderValue`),
                value: 'nettoOrderValue',
            },
            {
                label: this.$t(`excludedReferralFields.leadCommission`),
                value: 'leadCommission',
            },
        ]
    }
}
